import { faPen } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Grid, Typography } from "@mui/material"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"

interface ICampaignSummaryItemLayoutProps {
  id: string
  title: string
  isEditable: boolean
  onEdit: () => any
  sxContent?: any
  xs?: number
  md?: number
  xl?: number
}

export class CampaignSummaryItemLayout extends React.PureComponent<ICampaignSummaryItemLayoutProps, {}> {
  public render() {
    const { id, title, isEditable, children, sxContent, xs, md, xl, onEdit } = this.props
    return (
      <Grid item xs={xs || 12} md={md || 6} xl={xl || 4}>
        <FlexBox
          id={`summary-${id}`}
          vertical
          jc="start"
          fullWidth
          sx={{
            "minWidth": "100%",
            "maxWidth": "100%",
            "height": "100%",
            "minHeight": "16rem",
            "backgroundColor": theme => theme.palette.background.default,
            "& .edit-icon": {
              color: theme => theme.palette.text.secondary,
              cursor: "pointer"
            },
            "& .edit-icon:hover": {
              color: theme => theme.palette.text.primary
            }
          }}>
          <FlexBox
            jc="space-between"
            sx={{ width: "100%", p: "1rem", pl: "2rem", pr: "2rem", borderBottom: theme => theme.palette.border }}>
            <Typography color="textPrimary" fontSize="1.1rem" fontWeight={500}>
              {title}
            </Typography>
            {isEditable ? (
              <FontAwesomeIcon
                id={`summary-${id}-button`}
                icon={faPen}
                className="edit-icon"
                onClick={() => onEdit()}
              />
            ) : (
              <div />
            )}
          </FlexBox>
          <Grid container gap={2} sx={{ height: "100%", p: ".5rem", pl: "1rem", pr: "1rem", ...sxContent }}>
            {children}
          </Grid>
        </FlexBox>
      </Grid>
    )
  }
}
